import { render, staticRenderFns } from "./CartLists.vue?vue&type=template&id=40bbc2e4&scoped=true&"
import script from "./CartLists.vue?vue&type=script&lang=js&"
export * from "./CartLists.vue?vue&type=script&lang=js&"
import style0 from "./CartLists.vue?vue&type=style&index=0&id=40bbc2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbc2e4",
  null
  
)

export default component.exports